import { offlineQueue } from './offline-queue.service';

export interface PendingInternalMessagePayload {
  channel: 'internal';
  projectId: string;
  projectName?: string;
  content: string;
  attachments?: Array<{
    url: string;
    name: string;
    type: string;
    size: number;
  }>;
  created_at: number;
}

export const offlineMessageService = {
  async saveLocal(
    payload: Omit<PendingInternalMessagePayload, 'channel' | 'created_at'>
  ): Promise<string> {
    const localRef = `msg-${crypto.randomUUID()}`;
    const fullPayload: PendingInternalMessagePayload = {
      ...payload,
      channel: 'internal',
      created_at: Date.now(),
    };
    await offlineQueue.enqueue('message', 'create', fullPayload, localRef);
    return localRef;
  },

  async listLocalPending(projectId: string): Promise<PendingInternalMessagePayload[]> {
    const all = await offlineQueue.listByEntity('message');
    return all
      .filter((i) => i.status === 'pending' || i.status === 'failed')
      .filter((i) => (i.payload as any)?.channel === 'internal')
      .filter((i) => (i.payload as any)?.projectId === projectId)
      .map((i) => i.payload as PendingInternalMessagePayload);
  },
};